import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'
import { getReportTimeZone } from '@/lib/date-range'

import type {
  GetAffiliateAnalyticsParams,
  GetAffiliateAnalyticsResponse,
} from './get-affiliate-analytics.types'

export const getAffiliateAnalytics = async (
  params: GetAffiliateAnalyticsParams,
): Promise<GetAffiliateAnalyticsResponse> => {
  const response = await apiClient.get<GetAffiliateAnalyticsResponse>(
    '/v1/affiliation/analytics',
    {
      params: {
        From: params.from,
        To: params.to,
        // Omitted rather than sent empty: the endpoint reads a missing CodeId
        // as "every code of this affiliate".
        ...(params.codeId ? { CodeId: params.codeId } : {}),
        TimeZone: getReportTimeZone(),
      },
    },
  )
  return response.data
}

export const useGetAffiliateAnalytics = (
  params: GetAffiliateAnalyticsParams,
) => {
  return useQuery({
    queryKey: ['affiliate-analytics', params],
    queryFn: () => getAffiliateAnalytics(params),
  })
}
